
import InputField from '@/components/neue/InputField'
import { DECIMAL_NUMBER_PATTERN } from '@/helpers/discountFormat'
import api from '@/store/api'

export default {
  components: { InputField },
  setup() {
    return { decimalNumberPattern: DECIMAL_NUMBER_PATTERN }
  },
  data() {
    return {
      type: '',
      discount_code_name: '',
      code: '',
      codeError: '',
      discount_rate: '',
      maximum_discount_amount: { dollars: '' },
      discount_amount: { dollars: '' },
      max_use_times_per_user: '',
      can_be_combined: false,
      can_be_combined_always: false,
      code_can_expire: false,
      expiration_date: '',
      first_time_customer_only: false,
      auto_apply_once_used: false,
      automatically_apply: false
    }
  },
  watch: {
    code() {
      const regexPattern = new RegExp('[^A-Za-z0-9_-]*$', 'g')
      this.code = this.code.toUpperCase().replace(/\s/g, '-').replace(regexPattern, '')
      this.codeError = ''
    }
  },
  methods: {
    handleKeydown(event) {
      // 'Enter' outside textarea
      if (event.keyCode === 13 && event.target.localName !== 'textarea') event.preventDefault()
    },
    handleSubmit() {
      this.codeError = ''

      const sendData = { ...this.$data }

      sendData.discount_rate = this.discount_rate / 100
      sendData.discount_amount_cents = sendData.discount_amount.dollars * 100
      delete sendData.discount_amount
      sendData.maximum_discount_amount_cents = sendData.maximum_discount_amount.dollars * 100
      delete sendData.maximum_discount_amount

      api
        .call('POST', `discount_codes`, {
          discount_code: sendData
        })
        .then(response => {
          this.$router.replace('/store/discount-codes/' + response.data.data.id)
        })
        .catch(error => {
          if (error.response?.status === 422) {
            const message = error.response.data?.errors?.[0]
            this.codeError = message || 'This code is already taken.'
            return
          }
          this.codeError = 'Unable to save right now. Please try again.'
        })
    }
  }
}
